<template>
    <div class="flex-grow-1 overflow-y-auto p-0 w-100 h-100">
        <div class="py-4 px-4 bg-white border-bottom" :class="form?.title_align || 'text-center'">
            <h1 class="fw-bolder m-0" :style="{ color: form?.title_color || '#5F0487', fontSize: '1.8rem' }">
                {{ form?.title || 'Título da Página' }}
            </h1>
        </div>

        <div v-if="!form?.sections || form.sections.length === 0" class="text-center text-muted py-5">
            <i class="bi bi-puzzle fs-1 d-block mb-2"></i>
            <span class="small">Sua página está vazia.</span>
        </div>

        <div v-for="(section, idx) in form?.sections || []" :key="'prev_' + idx"
            :class="section.type !== 'dailypag_crowdfunding' ? 'py-5 px-4' : ''"
            :style="section.type !== 'dailypag_crowdfunding' ? { backgroundColor: section.content?.bg_color || '#ffffff' } : {}">

            <!-- PREVIEW: RMR CROWDFUNDING -->
            <div v-if="section.type === 'dailypag_crowdfunding'" class="rmr-crowdfunding-container p-3 p-md-4" style="background-color: #f8fafc;">
                <div class="row g-4">
                    <div class="col-lg-12 col-xl-7">
                        <div class="position-relative mb-3">
                            <img :src="section.content.cover_image || 'https://via.placeholder.com/800x450?text=Sua+Capa+Aqui'"
                                 class="img-fluid rounded-4 w-100 object-fit-cover shadow-sm" style="height: 300px; border: 1px solid #e2e8f0;">
                            <div class="position-absolute top-0 end-0 m-3 bg-white text-dark fw-bold rounded-pill px-3 py-1 shadow-sm fs-7">
                                <i class="bi bi-tag-fill me-1" style="color: #5F0487;"></i> {{ section.content.category }}
                            </div>
                        </div>

                        <h2 class="fw-bolder text-dark mb-2" style="font-size: 1.7rem; letter-spacing: -0.5px;">{{ section.content.title }}</h2>

                        <p class="text-muted lh-base mb-3" style="font-size: 0.95rem;">
                            <i class="bi bi-geo-alt-fill me-1" style="color: #5F0487;"></i> {{ section.content.location }}
                        </p>

                        <p class="text-secondary lh-base mb-4 bg-white p-3 rounded-3 border border-light shadow-sm" style="font-size: 0.95rem;">
                            {{ section.content.short_description }}
                        </p>

                        <ul class="nav nav-tabs rmr-tabs border-bottom-0 mb-3">
                            <li class="nav-item">
                                <button class="nav-link active fw-bold border-0 border-bottom border-3 px-2 me-3 bg-transparent" style="color: #5F0487; border-color: #5F0487 !important;">Nossa História</button>
                            </li>
                            <li class="nav-item">
                                <button class="nav-link fw-medium text-muted border-0 px-2 me-3 bg-transparent">Mural de Apoio</button>
                            </li>
                        </ul>

                        <div class="bg-white p-4 rounded-4 shadow-sm border border-light">
                            <div v-if="section.content.pix_key" class="alert d-flex align-items-center mb-4" style="background-color: #f3e8f5; border: 1px solid #dcb5e6;">
                                <i class="bi bi-lightning-charge-fill fs-4 me-3" style="color: #5F0487;"></i>
                                <div>
                                    <span class="d-block small fw-bold" style="color: #5F0487;">Doação rápida via PIX:</span>
                                    <span class="text-dark">{{ section.content.pix_key }}</span>
                                </div>
                            </div>
                            <div class="rich-preview text-secondary lh-lg" style="font-size: 0.9rem;" v-html="section.content.about_text"></div>
                        </div>
                    </div>

                    <div class="col-lg-12 col-xl-5">
                        <div class="position-sticky" style="top: 20px;">
                            <div class="bg-white p-4 rounded-4 shadow-sm border border-light mb-3 text-center">
                                <p class="text-muted fw-bold mb-1 text-uppercase" style="font-size: 0.75rem;">Total Arrecadado</p>
                                <h2 class="fw-bolder mb-2" style="font-size: 2.2rem; letter-spacing: -1px; color: #5F0487;">
                                    R$ {{ formatCurrency(section.content.raised_amount) }}
                                </h2>
                                <p class="text-muted mb-4" style="font-size: 0.85rem;">objetivo: R$ {{ formatCurrency(section.content.goal_amount) }}</p>

                                <div class="progress mb-4 bg-light shadow-inner" style="height: 10px; border-radius: 20px;">
                                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                                         :style="{ width: ((section.content.raised_amount / section.content.goal_amount) * 100) + '%', backgroundColor: '#5F0487' }"></div>
                                </div>

                                <div class="d-flex justify-content-center gap-4 mb-4">
                                    <div class="text-center">
                                        <div class="fw-bold text-dark fs-5">{{ section.content.supporters_count }}</div>
                                        <div class="small text-muted">Apoiadores</div>
                                    </div>
                                    <div class="vr opacity-25"></div>
                                    <div class="text-center">
                                        <div class="fw-bold text-dark fs-5">{{ section.content.goal_amount > 0 ? Math.floor((section.content.raised_amount / section.content.goal_amount) * 100) : 0 }}%</div>
                                        <div class="small text-muted">Alcançado</div>
                                    </div>
                                </div>

                                <button @click="$emit('openCheckout', section.content)"
                                        class="btn w-100 py-3 fw-bold rounded-pill mb-2 shadow-sm btn-rmr-primary">
                                    Quero Ajudar Agora
                                </button>
                                <button class="btn btn-light w-100 py-2 fw-medium rounded-pill border text-dark">
                                    <i class="bi bi-share me-1"></i> Compartilhar
                                </button>
                            </div>

                            <div class="bg-white p-3 rounded-4 shadow-sm border border-light d-flex align-items-center gap-3">
                                <div class="rounded-circle text-white d-flex align-items-center justify-content-center fw-bold fs-5 shadow-sm" style="width: 45px; height: 45px; background-color: #5F0487;">
                                    {{ getInitials(section.content.creator_name) }}
                                </div>
                                <div class="text-start">
                                    <div class="small text-muted mb-0 lh-1">Organizado por:</div>
                                    <h6 class="fw-bold text-dark mb-0 mt-1" style="font-size: 0.95rem;">{{ section.content.creator_name || 'Usuário' }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- PREVIEW: TEXTO RICO -->
            <div v-else-if="section.type === 'text'">
                <h2 v-if="section.content?.title" class="fw-bolder mb-3" :style="{ color: section.content?.accent_color || '#5F0487' }">{{ section.content.title }}</h2>
                <div class="m-0 rich-preview w-100" :style="{ color: section.content?.accent_color || '#374151' }" v-html="section.content?.text"></div>
            </div>

            <!-- PREVIEW: YOUTUBE -->
            <div v-else-if="section.type === 'youtube'" class="text-center">
                <h3 v-if="section.content?.title" class="fw-bolder mb-3" :style="{ color: section.content?.accent_color || '#5F0487' }">{{ section.content.title }}</h3>
                <div class="bg-dark rounded-4 d-flex align-items-center justify-content-center mx-auto shadow" style="height: 180px; max-width: 320px; border: 4px solid #fff;">
                    <i class="bi bi-play-circle-fill text-white fs-1"></i>
                </div>
            </div>

            <!-- PREVIEW: CONTATO -->
            <div v-else-if="section.type === 'contact'" class="text-center">
                <h3 class="fw-bolder mb-3" :style="{ color: section.content?.accent_color || '#5F0487' }">
                    {{ section.content?.title || 'Fale Conosco' }}
                </h3>
                <div class="d-flex justify-content-center gap-3 flex-wrap">
                    <span v-if="section.content?.whatsapp" class="badge rounded-pill bg-success px-4 py-2 fs-6 shadow-sm"><i class="bi bi-whatsapp me-2"></i>{{ section.content.whatsapp }}</span>
                    <span v-if="section.content?.email" class="badge rounded-pill bg-dark px-4 py-2 fs-6 shadow-sm"><i class="bi bi-envelope me-2"></i>{{ section.content.email }}</span>
                </div>
            </div>

            <!-- PREVIEW: PAGAMENTO GENÉRICO -->
            <div v-else-if="section.type === 'payment'" class="text-center">
                <button class="btn btn-lg fw-bold rounded-pill shadow-lg px-5 py-3" style="background-color: #5F0487; color: white;">
                    <i class="bi bi-cart me-2"></i> {{ section.content?.button_text || 'Comprar' }}
                </button>
            </div>

            <!-- PREVIEW: CARROSSEL -->
            <div v-else-if="section.type === 'carousel'">
                <h3 class="fw-bolder mb-4 text-center" :style="{ color: section.content?.accent_color || '#5F0487' }">{{ section.content?.title }}</h3>
                <div class="d-flex gap-3 overflow-x-auto pb-3 justify-content-center px-2">
                    <div v-for="(img, i) in (section.content?.images || [])" :key="i" class="flex-shrink-0 rounded-4 overflow-hidden shadow-sm" style="width: 150px; height: 150px; border: 3px solid #fff;">
                        <img v-if="img.url" :src="img.url" style="width: 100%; height: 100%; object-fit: cover;"/>
                        <div v-else class="d-flex align-items-center justify-content-center h-100 bg-light text-muted small"><i class="bi bi-image fs-3"></i></div>
                    </div>
                </div>
            </div>

            <!-- OUTROS -->
            <div v-else class="text-center">
                <h3 class="fw-bold mb-2">{{ section.content?.title || 'Título' }}</h3>
                <p class="text-muted">{{ section.content?.subtitle || 'Subtítulo...' }}</p>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'PagePreviewRenderer',
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatCurrency(v) {
            return parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        getInitials(name) {
            if (!name) return 'R';
            const parts = name.trim().split(' ');
            if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
            return name.substring(0, 2).toUpperCase();
        }
    }
}
</script>

<style scoped>
.btn-rmr-primary {
    background-color: #5F0487;
    color: white;
    transition: all 0.2s ease-in-out;
}
.btn-rmr-primary:hover {
    background-color: #4a036a;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(95, 4, 135, 0.3) !important;
}
.shadow-inner {
    box-shadow: inset 0 2px 4px rgba(0,0,0,0.06);
}
.rmr-tabs .nav-link {
    color: #6c757d;
    padding-bottom: 10px;
}
</style>